import { 
    Box,
    useTheme,
    Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { CONTACT_EMAIL } from "../../config";
import store from '../../store';
import { setIsCookieConsentOpen } from "../../slices/isCookieConsentOpenSlice";

const links = [
    { text: 'Privacy Policy', href: '/privacy' },
    { text: 'Terms and Conditions', href: '/terms-conditions' },
    { text: 'Contact Us', href: `mailto:${CONTACT_EMAIL}` },
    { text: 'Cookie Consent', onClick: () => store.dispatch(setIsCookieConsentOpen(true)) },
    { text: 'Check Link', href: '/check' },
];

const Links = () => {
    const theme = useTheme();
    return (
        <Box sx={{
            display: 'flex', 
            flexWrap: 'wrap', 
            justifyContent: 'center',
            alignItems: 'center',
            gap: 3,
        }}>
            {
                links.map((current, index) => {
                    return current?.onClick ? (
                            <MuiLink 
                                key={index} 
                                component={RouterLink} 
                                onClick={current?.onClick}
                                underline="hover"
                                sx={{
                                    color: theme.palette.text.main,
                                }}
                            >
                                {current.text}
                            </MuiLink>
                        ) : 
                        (
                            <MuiLink 
                                key={index} 
                                component={RouterLink} 
                                to={current.href}
                                underline="hover"
                                sx={{
                                    color: theme.palette.text.main,
                                }}
                            >
                                {current.text}
                            </MuiLink>
                        )
                    }
                )
            }
        </Box>
    );
}

export default Links;